import api from '@/sui/api/api'
import delay from '@/sui/api/delay'

let module = null

const remote = true
if (remote) {
  module = {
    add (request) {
      return api.post('denominators/update', request)
    },

    update (request) {
      return api.post('denominators/update', request)
    },

    get (request) {
      return api.post('denominators/get', request)
    },

    status (request) {
      return api.post('denominators/status', request)
    }
  }
} else {
  module = {
    _all: [],

    add (request) {
      const list = this._all
      const id = list.length
      request.id = String(id)
      list.push(request)
      return delay(150)({
        data: {
          id: id
        }
      })
    },

    update (request) {
      const id = request.id
      this._all[id] = request
      return delay(1450)({
        data: {
          id: id
        }
      })
    },

    get (request) {
      const result = this._all.find(e => e.s === request.s)
      const data = {
      }

      if (result != null) {
        data.v = result
      } else {
        data.v = { f: {} }
      }

      return delay(400)({ data: data })
    }
  }
}
export default module
